// import { makeStyles } from '@mui/styles';
import SettingsIcon from '@mui/icons-material/Settings';
import Typography from '@mui/material/Typography';
// import Logo from `assets/${process.env.REACT_APP_ASSETS_FOLDER}/logo.png`;
import { memo } from 'react';
import { AppBar, Layout, Logout, MenuItemLink, Sidebar, UserMenu, useTranslate } from 'react-admin';
import FileManagerModalInput from 'utils/react-admin/inputs/FileManagerModalInput';
import LinkInput from 'utils/react-admin/inputs/LinkInput';
import QrCodeLogoInput from 'utils/react-admin/inputs/QrCodeLogoInput';
import DevAppBar from './DevAppBar';
import DevToolsAppBar from './DevToolsAppBar';
import MyMenu from './Menu';
// import menu from './views/layout/Menu';


const MySidebar = (props: any) => {
  return (
    <Sidebar {...props} />
  );
};

const MyUserMenu = () => {
  const translate = useTranslate();

  return (
    <UserMenu>
      <MenuItemLink
        style={{ color: 'rgba(0, 0, 0, 0.54)' }}
        to="/my-profile"
        primaryText={translate(`menu.my_profile`)}
        leftIcon={<SettingsIcon style={{ color: 'rgba(0, 0, 0, 0.54)' }} />}
      />
      <Logout />
    </UserMenu>
  );
}

const MyAppBar = (props: any) => {
  // console.log(process.env);
  const Logo = require(`assets/logo.png`);
  return (
    <AppBar
      sx={{
        "& .RaAppBar-title": {
          flex: 1,
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden",
        },
      }}
      {...props}
      userMenu={<MyUserMenu />}
    >
      <Typography
        variant="h6"
        color="inherit"
        id="react-admin-title"
      />
      <a className="app-bar-logo-anchor" target="_blank" href="/admin"><img className="app-bar-logo" src={Logo} alt={process.env.REACT_APP_TITLE} /></a>
      <span style={{ flex: 1 }} />
      {'development' === process.env.NODE_ENV ? <DevAppBar /> : null}
      <FileManagerModalInput buttonOnly />
      <LinkInput buttonOnly />
      <QrCodeLogoInput buttonOnly />
      <DevToolsAppBar />
    </AppBar>
  );
};


const ProjectLayout = (props: any) => <Layout {...props} menu={MyMenu} appBar={MyAppBar} sidebar={MySidebar} />;

export default memo(ProjectLayout);
